import React, { useState, useContext, useRef, useEffect } from "react";
import axios from "axios";
import { API_BASE_URL, API_KEY } from "../../../config/config";
import { AuthContext } from "../../../context/authContext";
import qs from "qs";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronUp, faExpandArrowsAlt, faReply } from "@fortawesome/free-solid-svg-icons";

const CommentForm = ({ video, addNewComment, onCommentSubmit }) => {
	const { visitor } = useContext(AuthContext);
	const [content, setContent] = useState('');
	const [isSubmitting, setIsSubmitting] = useState(false);
	const [error, setError] = useState('');
	const textareaRef = useRef(null);

	useEffect(() => {
		adjustTextareaHeight();
	}, [content]);

	const handleContentChange = (event) => {
		setContent(event.target.value);
		adjustTextareaHeight();
	};

	const handleSubmit = async (event) => {
		event.preventDefault();
		setIsSubmitting(true);
		setError('');

		if (!content.trim()) {
			setError('Please enter a message');
			setIsSubmitting(false);
			return;
		}

		try {
			let data = qs.stringify({
				'thread_id': video.Post.thread_id,
				'message': content,
			});

			let config = {
				method: 'post',
				maxBodyLength: Infinity,
				url: `${API_BASE_URL}/threads/${video.Post.thread_id}/reply`,
				headers: {
					'XF-Api-Key': API_KEY,
					'XF-Api-User': visitor.user_id,
					'Content-Type': 'application/x-www-form-urlencoded'
				},
				data: data,
				withCredentials: true
			};

			const response = await axios.request(config);
			let comment = response.data.post;

			addNewComment(comment);
			onCommentSubmit();
			setContent('');
		} catch (error) {
			console.error('Failed to post comment:', error);
			setError('Failed to post comment. Please try again.');
		} finally {
			setIsSubmitting(false);
		}
	};

	const adjustTextareaHeight = () => {
		const textarea = textareaRef.current;
		textarea.style.height = 'auto';
		textarea.style.height = `${Math.min(textarea.scrollHeight, 5 * 20)}px`; // 5 rows, assuming each row is approximately 20px high
	};

	return (
		<div className="flex-1 p-1 min-w-0">
			<div className="flex flex-col h-full">
				{error && <p className="mt-2 error text-red-500 font-bold text-sm">{error}</p>}

				<form onSubmit={handleSubmit} className="reply-form flex items-center gap-x-2">
					<div className="form-group min-w-0 flex-1">
			              <textarea
				              ref={textareaRef}
				              value={content}
				              onChange={handleContentChange}
				              className="form-control block w-full p-2 text-sm text-white border border-borderColor rounded-lg bg-primary focus:ring-primary focus:ring-opacity-85 focus:border-primary focus:border-opacity-85"
				              placeholder="Viết bình luận"
				              rows="1"
				              style={{resize: 'none', overflow: 'hidden'}}
				              disabled={isSubmitting}
			              />
					</div>

					<div className="flex-shrink-0 flex-grow-0">
						<button type="submit" className="w-[32px] text-white" disabled={isSubmitting}>
							<FontAwesomeIcon icon={faReply}/>
						</button>
					</div>
				</form>
			</div>
		</div>
	);
};

export default CommentForm;
